(function() {
    'use strict';
    
a3_cabin_reports.factory('CabinReportTemplateItemFactory', CabinReportTemplateItemFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportTemplateItemFactory
    * @description 
    *   Manage Cabin Report Template Item.
    * @ngInject
    */
function CabinReportTemplateItemFactory(GenericService) {

        /**
        * Initialize the CabinReportTemplateItem
        * @memberof CabinReportTemplateItemFactory
        */
		function CabinReportTemplateItem() {
			this.Id = null;
			this.Hint = null;
			this.Label = null;
			this.OrderNo = null;
			this.CategoryLabel = null;
			this.PresetComments = null;
			this.Photos = new Array();
			this.GetId = GetId;
		}

		var objType = 'cabinReportTemplateItems';
		var objCallback = CabinReportTemplateItem;

		var service = 
		{  
			getCabinReportTemplateItemsFromStorage : getCabinReportTemplateItemsFromStorage,
			setCabinReportTemplateItemsToStorage : setCabinReportTemplateItemsToStorage,
			newItem : newItem
		};
			
        /**
         * Overide default get Id
         * @memberof CabinReportTemplateItemFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}
			
         /**
         * Get Cabin Report Template Items
         * @memberof CabinReportTemplateItemFactory
         * @returns {Array} CabinReportTemplateItems 
         */
		function getCabinReportTemplateItemsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save Cabin Report Template Items to storage
         * @memberof CabinReportTemplateItemFactory
         * @param {Array} CabinReportTemplateItems A list of Cabin Report Template Items
         */
		function setCabinReportTemplateItemsToStorage(cabinReportTemplateItems) {
			GenericService.saveAll(cabinReportTemplateItems,objType,objCallback);
		}

        /**
         * Create a new Cabin Report Template Item 
         * @memberof CabinReportTemplateItemFactory
         * @return {object} CabinReportTemplateItem
         */
		function newItem() {
			return GenericService.constructor(objCallback);
		}

		return service;
	}

})();